import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ClientSignUp from '../../sections/SignUp/ClientSignUp';
import LawyerSignUp from '../../sections/SignUp/LawyerSignUp';
import AuthNavBar from '../../components/layout/AuthNavBar';
import { useAuthMode } from '../../redux/hooks';

export default function SignUp() {
  const { isLawyer, setClientMode, setLawyerMode } = useAuthMode();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AuthNavBar />
      <motion.div
        className="flex flex-col items-center justify-start px-4 py-1 pb-20"
        initial={false}
        animate={{ backgroundColor: isLawyer ? '#132A56' : '#fbfcf8' }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        style={{ minHeight: 'calc(100vh - 80px)' }}
      >
        <div className="w-full max-w-4xl mx-auto">
          <div className="text-center mb-6">
            <h1
              className={`text-5xl font-serif italic font-bold mb-1 ${isLawyer ? 'text-white' : 'text-gray-900'}`}
            >
              ¡Únete a nosotros!
            </h1>
            <h2
              className={`text-3xl font-light mb-6 ${isLawyer ? 'text-white' : 'text-gray-900'}`}
              style={{ minHeight: '2.5rem' }}
            >
              <AnimatePresence mode="wait">
                <motion.span
                  key={isLawyer ? 'lawyer' : 'client'}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.4, ease: 'easeInOut' }}
                  className="inline-block"
                >
                  {isLawyer
                    ? 'Regístrate, es hora de defender la justicia'
                    : 'Regístrate, tus problemas, resueltos'}
                </motion.span>
              </AnimatePresence>
            </h2>
          </div>

          {/* Tab Navigation */}
          <div className="flex justify-center mb-8">
            <div
              className={`flex relative ${isLawyer ? 'border-b border-gray-500' : 'border-b border-gray-300'}`}
            >
              <button
                type="button"
                className={`px-8 py-3 text-lg font-medium transition-colors duration-200 relative ${
                  !isLawyer
                    ? isLawyer
                      ? 'text-white'
                      : 'text-black'
                    : isLawyer
                      ? 'text-gray-400'
                      : 'text-gray-500'
                }`}
                onClick={() => setClientMode()}
              >
                Soy Cliente
                {!isLawyer && (
                  <div
                    className={`absolute bottom-0 left-0 right-0 h-0.5 transition-all duration-200 ${
                      isLawyer ? 'bg-white' : 'bg-black'
                    }`}
                  />
                )}
              </button>
              <button
                type="button"
                className={`px-8 py-3 text-lg font-medium transition-colors duration-200 relative ${
                  isLawyer
                    ? isLawyer
                      ? 'text-white'
                      : 'text-black'
                    : isLawyer
                      ? 'text-gray-400'
                      : 'text-gray-500'
                }`}
                onClick={() => setLawyerMode()}
              >
                Soy Abogado
                {isLawyer && (
                  <div
                    className={`absolute bottom-0 left-0 right-0 h-0.5 transition-all duration-200 ${
                      isLawyer ? 'bg-white' : 'bg-black'
                    }`}
                  />
                )}
              </button>
            </div>
          </div>
          <AnimatePresence mode="wait">
            {!isLawyer && (
              <motion.div
                key="cliente"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 40 }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
              >
                <ClientSignUp isLawyer={false} />
              </motion.div>
            )}
            {isLawyer && (
              <motion.div
                key="abogado"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 40 }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
              >
                <LawyerSignUp isLawyer={true} />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </>
  );
}
